/** Обращения к API админки. */

export class ApiError extends Error {
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }

  /** Пользователь не вошёл либо сессия истекла. */
  get isUnauthorized(): boolean {
    return this.status === 401;
  }
}

async function parseError(response: Response): Promise<never> {
  let message = `Ошибка ${String(response.status)}`;

  try {
    const payload: unknown = await response.json();
    if (typeof payload === 'object' && payload !== null && 'error' in payload && typeof payload.error === 'string') {
      message = payload.error;
    }
  } catch {
    // Ответ без JSON — оставляем общий текст.
  }

  throw new ApiError(response.status, message);
}

export async function apiGet<T>(path: string, signal?: AbortSignal): Promise<T> {
  const response = await fetch(path, {
    credentials: 'same-origin',
    headers: { accept: 'application/json' },
    ...(signal === undefined ? {} : { signal }),
  });

  if (!response.ok) {
    return parseError(response);
  }

  return (await response.json()) as T;
}

async function send<T>(method: string, path: string, body?: unknown): Promise<T> {
  const response = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers: {
      accept: 'application/json',
      ...(body === undefined ? {} : { 'content-type': 'application/json' }),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });

  if (!response.ok) {
    return parseError(response);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return (await response.json()) as T;
}

export const apiPost = <T,>(path: string, body?: unknown): Promise<T> => send<T>('POST', path, body);

/** Выход: сессия закрывается на сервере, страница загружается начисто. */
export async function apiLogout(): Promise<void> {
  await apiPost('/auth/logout');
  window.location.assign('/');
}

export const apiPatch = <T,>(path: string, body?: unknown): Promise<T> => send<T>('PATCH', path, body);
export const apiDelete = <T,>(path: string): Promise<T> => send<T>('DELETE', path);
